import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Input,
  Spacer,
  useDisclosure,
  VStack,
  Image,
  Text,
  Select,
} from "@chakra-ui/react";
import { useGiftsMaster } from "../../store/giftcards/reducer";
import { REQUEST_MASTER_GIFTS } from "../../store/giftcards/giftcardsActionTypes";
import GiftsMasterTable from "../../components/GiftsMasterTable/GiftsMasterTable";

const Giftcards = () => {
  const { masterGifts, busy } = useGiftsMaster();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: REQUEST_MASTER_GIFTS });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [searchQuery, setSearch] = useState("");
  return (
    <>
      <VStack top={5} position="relative" key={"vStack"}>
        <Flex w="92%" alignItems="center" justifyContent="space-between">
          <Heading ml="8" size="md" fontWeight="semibold" color="black.400">
            Giftcards
          </Heading>
          <Spacer></Spacer>
          <Heading size="sm" fontWeight="semibold">
            <Flex alignItems="center" gap={2}>
              <Image
                borderRadius="full"
                boxSize="50px"
                src="https://bit.ly/dan-abramov"
                alt="Dan Abramov"
              />
              <Text>Admin</Text>
            </Flex>
          </Heading>
        </Flex>
      </VStack>
      <GiftsMasterTable query={searchQuery} />
    </>
  );
};

export default Giftcards;
